import { useMemo } from 'react';
import useSWR from 'swr';

import { fetcher } from 'services/fetcher';
import { StocksReference, StockVariante } from 'types/StocksReference';

export function useProductStocks(
  reference: string
): {
  MAX_AVAILABLE_QUANTITY: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  isValidReference: boolean;
  getProduct: getProductType;
  getProductStock: getProductStockType;
  getAvailableQuantities: getAvailableQuantitiesType;
  stocks: StocksReference | undefined;
  stocksVariante: StockVariante[];
} {
  const MAX_AVAILABLE_QUANTITY = 9;
  const refRegex = new RegExp(/([A-Z]|[0-9]){7}/g);
  const { data: stocks, error } = useSWR<StocksReference>(
    refRegex.test(reference.replace('.', ''))
      ? `${
          process.env.REACT_APP_URL_API_CATALOG
        }/stock/reference/${reference.replace('.', '')}`
      : null,
    fetcher
  );

  const isValidReference =
    stocks?.CODE_RETOUR === '0' && typeof stocks.VARIANTE === 'object';

  // Use the memo because uniq size data is transformed into an array, but the array reference is new on each new render
  const stocksVariante = useMemo(() => {
    if (stocks && isValidReference) {
      return Array.isArray(stocks?.VARIANTE)
        ? stocks.VARIANTE
        : [stocks.VARIANTE];
    }

    return [];
  }, [stocks, isValidReference]);

  function getProduct(sku: string): StockVariante | undefined {
    return stocksVariante.find(product => product?.REFREEL == sku);
  }

  function getProductStock(sku: string): number | undefined {
    const productStock = stocksVariante.find(
      product => product?.REFREEL == sku
    );

    return productStock ? parseInt(productStock.QUANTITE_STOCK) : undefined;
  }

  function getAvailableQuantities(): number[] {
    return [1, 2, 3, 4, 5, 6, 7, 8, 9];
  }

  return {
    MAX_AVAILABLE_QUANTITY,
    error,
    isValidReference,
    getProduct,
    getProductStock,
    getAvailableQuantities,
    stocks,
    stocksVariante,
  };
}

type getProductType = (sku: string) => StockVariante | undefined;

type getProductStockType = (sku: string) => number | undefined;

type getAvailableQuantitiesType = () => number[];
